import React, { useEffect } from "react";
import {useTranslation} from "react-i18next";
import { Button, Modal, Form } from "react-bootstrap";
import {useForm, Yup} from '../forms/form'
import FormGroup from '../forms/FormGroup'
import Icon from "../Icon";
import { useCreatePublisherMutation } from "../../api/publisherApiSlice";
import FormRowCol from '../forms/FormRowCol';
import { useHistory } from 'react-router';

export default function NewModalForm(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const [createPublisher ] = useCreatePublisherMutation()
  const initialValues = {
    name: "",
    username: ""
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(),
    username: Yup.string().required()
  });

  const { formData, setFormData, getInputProps, formProps, submitButtonProps } = useForm({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: () => {
      createPublisher(formData).then(response => {
        history.push(`/publishers/${response.data.slug}`)
      })
    },
  });

  useEffect(() => {
    if(formData.name) {
      setFormData({...formData, username: formData.name.toLowerCase().replace(/[ ]/g,'_').replace(/[^a-zA-Z_]/g,'')})
    }
  }, [formData.name])


  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {t("publisher.new")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form {...formProps}>
          <FormGroup
          as={FormRowCol}
          label={t("publisher.name")}
          input="text"
          {...getInputProps("name")}/>
          <FormGroup
          as={FormRowCol}
          label={t("publisher.username")}
          input="text"
          {...getInputProps("username")}/>
      </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' key="cancel" onClick={props.onHide}>
          <Icon icon='cancel' text={t("cancel")} />
        </Button>
        <Button key="submit" type="submit" variant="primary" {...submitButtonProps}>
          <Icon icon='save' text={t("save")} />
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
